
    $(function () {
//     console.log("Custom Product Options");


    if ($('#custom_snippet_option').length) {

        var optionSection = $('#custom_snippet_option');
        var getProductHandle = $('#custom_snippet_option').attr('data-product-handle');
        var getShopUrl = $('#custom_snippet_option').attr('data-shop-url');
        var optionTempates;

//         console.log(getProductHandle);
//         console.log(getShopUrl);

        var getOptionUrl = "https://product-customization-live-be.alche.cloud/product_details";
        var getCombinationUrl = "https://product-customization-live-be.alche.cloud/customize_product_details";
//         console.log(getOptionUrl);

        var combinationArra = [];
        var combinationImgArra = [];
        var combinationImage = '';

        var windowsWidth = $('#modal_switch_options').width();
        // console.log(h);

        // Get All All options style Request....
        $.ajax({
            url: getOptionUrl,
            type: "GET",
            data: {
                "shop": getShopUrl,
                "product_handle": getProductHandle
            },
            success: function (resp) {
                console.log("Success");
              console.log("Template Response: ", resp);
                optionTempates = resp.product_customization.templates;
                console.log(optionTempates);
                generateOption(optionTempates);
            },
            error: function (err) {
                console.log("Failed");
                console.log(err)
            }
        });
      
      	

        function slideFunctionality()
        {
            $('#modal_switch_options .modal-option-temp-wrap > div').css({'width': windowsWidth + 'px', 'min-width': windowsWidth + 'px'});
        }

        // Create Option Style DOM get From API
        function generateOption(optionArra) {

//             console.log(optionArra);
          
          	if (optionArra.length)
            {
              $('#custom_snippet_option').show()
            }

            let optionElement = '';
            let modalOptionElement = '';
            let modalOptionMaster = '';
            let optionArraLength = optionArra.length;
//             console.log(optionArraLength);
            $(optionArra).each(function (index, item) {
//                 console.log(index, item);

                // Default Options
                optionElement += `<label data-template-name="${item.template_name}" data-main-option>
                <div class="option-main-img-wrap">
                <img src="https://placehold.co/100x100/f1f1f1/ddd?text=Default" class="option-img">
                </div>
                <h6 class="option-title">${item.template_name}</h6>
                <span class="option-value">Default</span>
                <input type="hidden" name="properties[${item.template_name}]" value="Default" readonly>
                </label>`;


                // Create Style Elements of options in POPUP
                let optionItemEl = '';

                $(item.product_details).each(function (index, optionItem) {
                    optionItemEl += `<div class="modal-option-temp-all-item">
                    <div class="modal-option-temp-inner-wrap">
                    <input type="radio" name="${item.template_name}" value="${optionItem.style_name}" id="${optionItem.style_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}">
                    <label for="${optionItem.style_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}">
                    <div class="modal-option-temp-img-wrap"><img src="${optionItem.style_src === null ? 'https://placehold.co/100x100/f7f7f7/ddd?text=' + optionItem.style_name : optionItem.style_src}"></div>
                    <p>${optionItem.style_name.replaceAll('-', ' ')}</p>
                    </label>
                    </div>
                    </div>`;
                });

                // <img src="${optionItem.style_src === null ? 'https://placehold.co/80x100?text=' + optionItem.style_name : optionItem.style_src}">

                // console.log(optionItemEl);

                // Create Option Element in POPup
                modalOptionElement += `<div class="modal-option-temp-item" data-step-index="${ index + 1 }">
                <h3>Select ${item.template_name}</h3>
                <div class="modal-option-temp-inner">
                <div class="modal-option-temp-default">
                <div class="modal-option-temp-inner-wrap">
                <input type="radio" name="${item.template_name}" value="" id="${item.template_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}" checked>
                <label for="${item.template_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}">
                <div class="modal-option-temp-img-wrap"><img src="https://placehold.co/150x150/f7f7f7/ddd?text=Default"></div> 
                <p>Default</p>
                </label>
                </div>
                </div>
                ${optionItemEl}
                </div>
                <div class="modal-option-slide-action">
                <button class="btn" data-slide-back>Back</button>

                </div>
                </div>`

                modalOptionMaster +=  `<div class="modal-option-temp-master-item" data-target-index="${ index + 1 }" data-template-name="${item.template_name}" modal-slide-trigger>
                <div class="option-temp-master-wrap"><div class="option-img-wrap"><img src="https://placehold.co/150x150/f7f7f7/ddd?text=Default" class="option-img"></div>
                <h6 class="option-title">${item.template_name}</h6>
                <span class="option-value">Default</span>
                </div>
                </div>`
            });
          
//           Next Button 
//          ${ index === optionArraLength -1 ? '' : '<button class="btn" data-slide-next>Next</button>' } 
          
          
            // Append  Default Option 
            $(optionSection).find('#custom_option_outer_wrap .custom-option-inner .custom-option-inner-wrap').append(optionElement);

            // Append POPUP Option Style in POPUP
            $(modal_switch_options).find('.modal-option-temp-master').append(modalOptionMaster);
            $(modal_switch_options).find('.modal-option-temp-wrap').append(modalOptionElement);
            // console.log(modalOptionElement);
            slideFunctionality();

            $('#modal_switch_options .modal-option-temp-inner input:checked').each(function () {
                if ($(this).val() == '')
                {
                    combinationArra.push('Default');
                }
                else
                {
                    combinationArra.push($(this).val());
                }
                combinationImgArra.push($(this).next('label').find('img').attr('src'));
            });
        }

        $(document).on('change', '#modal_switch_options .modal-option-temp-inner input', function () {
//             console.log("Change Radio");
            optionCombination()
            
            if ($('#saveBtn').is(':hidden'))
            {
            	$('#saveBtn').show();
            }

        });
        
        function optionCombination() {
            let comb = '';
            let combArra = [];
            let combImgArra = [];
            $('#modal_switch_options .modal-option-temp-inner input:checked').each(function (index) {

                if ($(this).val() != '') {
                    comb += '_' + $(this).val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                }

                if ($(this).val() == '')
                {
                    combArra.push('Default');
                }
                else
                {
                    combArra.push($(this).val());
                }
                combImgArra.push($(this).next('label').find('img').attr('src'));
            });
//             console.log(comb.replace(/^[_]+/g, ''));
            combinationCall(comb.replace(/^[_]+/g, ''));
          
          $('#loading-screen').css('display', 'flex');
          
//             console.log(combArra);
            combinationArra = combArra;
//             console.log(combinationArra);
            combinationImgArra = combImgArra;


            $('.modal-option-temp-master .modal-option-temp-master-item').each(function (index) {
                // $(this).find('input').val(combinationArra[index]);
                $(this).find('.option-value').text(combinationArra[index]);

                // if (combinationImgArra[i] != '')
                $(this).find('.option-img').attr('src', combinationImgArra[index]);
                // $('#custom_option_popup').css('display', 'none');
                // $('body').css('overflow', 'visible');
            })

            
        }

        function combinationCall(getCombination) {
            $.ajax({
                url: getCombinationUrl,
                type: "GET",
                data: {
                    "shop": getShopUrl,
                    "product_handle": getProductHandle,
                    "combination": getCombination
                },
                success: function (resp) {
//                     console.log("Success");
//                     console.log(resp.image_src);
//                     console.log(resp);
                    
                    
                    // if (resp.combination_found == true)
                    // {
                        if (resp.image_src == '') {
    
                            let OrignalImgURL = $('#modal_main_image img').attr('data-img-src')
                            $('#modal_main_image img').attr('src', OrignalImgURL);
                            // $('#modal_main_image img').attr('src', 'https://placehold.co/400x550?text=No%20Image%20Found');
                            combinationImage = '';
                        }
                        // else if (resp.image_src == '')
                        // {
                        //     combinationImage = '';
                        // }
                        else {  
                            $('#modal_main_image img').attr('src', resp.image_src);
                            combinationImage = resp.image_src;
                        }
                    // }
                    // else
                    // {
                        
                    // }
                  
                  
                    $('#loading-screen').hide();
                  
                  

                },
                error: function (err) {
                    console.log("Failed");
                    console.log(err);
                }
            });
        }

        $('#saveBtn').on('click', function() {
            console.log(combinationArra);
            console.log(combinationImgArra);
            $('[data-main-option]').each(function (index) {
                $(this).find('input').val(combinationArra[index].replaceAll('-', ' '));
                $(this).find('.option-value').text(combinationArra[index].replaceAll('-', ' '));

                // if (combinationImgArra[i] != '')
                $(this).find('.option-img').attr('src', combinationImgArra[index]);
                $('#custom_option_popup').removeClass('popupOpen');
                $('body').css('overflow', 'visible');
            })

            $('#option_combination_image').val(combinationImage);
            if (combinationImage != '')
            {
              $('.product__media-container .product__media-item:first-child img').attr('srcset', combinationImage);
              $('.product__media-container .product__media-item:first-child img').attr('src', combinationImage);
                console.log(combinationImage)
                
                if ($('[data-product-slick-main-init]').length)
                {
                  console.log('has Slider')
                  
                  $('[data-product-slick-main-init] .slick-track .slick-slide').each(function() {
                    let getSlideIndex = $(this).attr('data-slick-index')
                    console.log(getSlideIndex)
                    if (getSlideIndex === '0')
                    {
                      console.log('THis is First SLide', getSlideIndex)
                      $(this).find('img').attr('srcset', combinationImage);
                      $(this).find('img').attr('src', combinationImage);
                    }
                  });
                  $('[data-product-slick-nav-init] .slick-track .slick-slide').each(function() {
                    let getSlideIndex = $(this).attr('data-slick-index')
                    console.log(getSlideIndex)
                    if (getSlideIndex === '0')
                    {
                      console.log('THis is First SLide', getSlideIndex)
                      $(this).find('img').attr('srcset', combinationImage);
                      $(this).find('img').attr('src', combinationImage);
                    }
                  });
                  $('[data-product-slick-nav-init]').slick('slickGoTo', 0);
                }
            }
            else
            {
                let OrignalImgURL = $('#modal_main_image img').attr('data-img-src')
                $('.product__media-container .product__media-item:first-child img').attr('src', OrignalImgURL);
                console.log(OrignalImgURL)
            }

            $(document).scrollTop(0)
            $('[modal-trigger] span').text('Back To Customise Style');
            console.log('Go to First Slide')
            
            
//             if ($('[data-product-slick-main-init]').length)
//             {
//               console.log('has Slider')
              
              
//             }
        })


        var isData = setTimeout(function () {
            if ($('#custom_option_outer_wrap .custom-option-inner').length) {
                clearInterval(isData);
                console.log('Data Exist');

                var modalTrigger = $('[modal-trigger]');
                var modal = $('#custom_option_popup');
                var modalContent = $(modal).find(".options-modal-dialog");

                $(document).on('click', '[modal-trigger]', function () {
                    $(modal).addClass('popupOpen');
                    $('body').css('overflow', 'hidden');
                    windowsWidth = $('#modal_switch_options').width();
                })

                $(document).on('click', '[modal-close]', function () {
                    $(modal).removeClass('popupOpen');
                    $('body').css('overflow', 'visible');
                    console.log('JJ');
                })

                $(modal).mouseup(e => {
                    if (!modalContent.is(e.target) && modalContent.has(e.target).length === 0) {
                        // $(modal).css('display', 'none');
                        $(modal).removeClass('popupOpen');
                        $('body').css('overflow', 'visible');
                    }
                });
            }

            
        }, 100);

        // var isModalData = setTimeout(function () {
        //     if ($('#modal_switch_options .modal-option-temp-item').length) {
        //         clearInterval(isModalData);
        //         console.log('Modal Data Exist');
        //     }
        // }, 100);

        $(document).on('click', '[modal-slide-trigger]', function () {
            let slideIndex = parseInt($(this).attr('data-target-index'));
            console.log($.type(slideIndex))
            // console.log($(this).attr('data-index'));
            gotoSlide(slideIndex)
        })

        function gotoSlide(getIndex)
        {
            let getMargin = -getIndex * windowsWidth;
            console.log(getMargin);
            var initalLeftMargin = $( "#modal_switch_options .modal-option-temp-wrap" ).css('margin-left').replace("px", "")*1;
            var newLeftMargin = (initalLeftMargin + getMargin); // extra 2 for border
            $("#modal_switch_options .modal-option-temp-wrap").animate({marginLeft: getMargin}, 200);
        }

//         $(document).on('click', '[data-slide-next]', function() {
//             console.log('Next');
//             var initalLeftMargin = $( "#modal_switch_options .modal-option-temp-wrap" ).css('margin-left').replace("px", "")*1;
//             var newLeftMargin = (initalLeftMargin - windowsWidth); // extra 2 for border
//             $( "#modal_switch_options .modal-option-temp-wrap" ).animate({marginLeft: newLeftMargin}, 200);
//         });

        $(document).on('click', '[data-slide-back]', function() {
            console.log('Back');
            var initalLeftMargin = $( "#modal_switch_options .modal-option-temp-wrap" ).css('margin-left').replace("px", "")*1;
//             var newLeftMargin = (initalLeftMargin + windowsWidth); // extra 2 for border
            $( "#modal_switch_options .modal-option-temp-wrap" ).animate({marginLeft: 0}, 200);
        });
    }
});
